import { useCallback } from "react";
import { useDataProvider } from "ra-core";

import type { Tag } from "../types";

export function useCreateTag() {
  const dataProvider = useDataProvider();

  return useCallback(
    async (data: Pick<Tag, "name" | "color">) => {
      const name = data.name.trim();
      if (!name) throw new Error("Введите название тега");
      const existing = await dataProvider.getList<Tag>("tags", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "name", order: "ASC" },
        filter: {},
      });
      const duplicate = existing.data.find(
        (tag) =>
          tag.name.trim().toLocaleLowerCase("ru-RU") ===
          name.toLocaleLowerCase("ru-RU"),
      );
      if (duplicate) return duplicate;
      const response = await dataProvider.create<Tag>("tags", {
        data: { ...data, name },
      });
      return response.data;
    },
    [dataProvider],
  );
}
